/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Nexy_TitleInputs */

const es_home_nexy_title = /** @type {(inputs: Home_Nexy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conoce a Nexy`)
};

const en_home_nexy_title = /** @type {(inputs: Home_Nexy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meet Nexy`)
};

/**
* | output |
* | --- |
* | "Meet Nexy" |
*
* @param {Home_Nexy_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_nexy_title = /** @type {((inputs?: Home_Nexy_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Nexy_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_nexy_title(inputs)
	return en_home_nexy_title(inputs)
});
export { home_nexy_title as "home.nexy.title" }